<!-- eslint-disable vue/no-v-html -->
<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="container-fluid">
          <Loader :loading="isLoading" />
          <loader-component v-if="isLoading" :loading="isLoading" />
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
                  <div class="card-body add-post">
                    <div class="row my-3">
                        <!-- Mostrar: dropdown para seleccionar usuarios por página -->
                        <div class="d-flex align-items-center mb-3">
                          <span class="me-2">Mostrar:</span>
                          <select 
                            v-model="itemsPerPage" 
                            @change="resetPagination"
                            class="form-select w-auto px-4 py-[9px] bg-white rounded-md text-black text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                          >
                            <option :value="10">10</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                          </select>
                          <span class="ms-2">registros</span>
                        </div>
                        <!-- Container para botón y filtros -->
                        <div class="flex flex-col md:flex-row md:justify-between md:items-center w-full mb-4 gap-3">
                          <!-- Botón a la izquierda -->
                          <button @click="goToPropertyForm(advisorId)" class="px-4 py-2 bg-[#FF4265] text-white text-sm font-medium rounded-md hover:bg-[#e03a5f] transition-colors duration-200 mb-2 md:mb-0">
                            Crear Propiedad
                          </button>

                          <!-- Botón toggle filtros (solo mobile) -->
                          <button 
                            @click="showFilters = !showFilters"
                            class="md:hidden px-4 py-2 bg-pink-500 text-white rounded-md flex items-center gap-2 justify-center"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                            </svg>
                            Filtros
                          </button>

                          <!-- Contenedor de filtros -->
                          <div 
                            class="filters-wrapper w-full md:w-auto"
                            :class="{ 'hidden md:flex': !showFilters, 'flex': showFilters }"
                          >
                            <div class="flex flex-col md:flex-row gap-2 w-full md:w-auto">
                              <!-- Selector de tipo de inmueble -->
                              <select 
                                v-model="propertyTypeFilter"
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              >
                                <option value="">Todos los tipos</option>
                                <option value="Casa">Casa</option>
                                <option value="Departamento">Departamento</option>
                                <option value="Terreno">Terreno</option>
                                <option value="Local">Local</option>
                                <option value="Oficina">Oficina</option>
                              </select>

                              <!-- Selector de estatus -->
                              <select 
                                v-model="statusFilter"
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              >
                                <option value="">Todos los estatus</option>
                                <option value="Activo">Activo</option>
                                <option value="Desactivado">Desactivado</option>
                                <option value="Sin estatus">Sin estatus</option>
                              </select>

                              <!-- Selector de tipo de movimiento -->
                              <select 
                                v-model="movementTypeFilter"
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                              >
                                <option value="">Todos los movimientos</option>
                                <option value="Venta">Venta</option>
                                <option value="Renta">Renta</option>
                                <option value="Remate">Remate</option>
                                <option value="Roomie">Roomie</option>
                                <option value="Venta o Renta">Venta o Renta</option>
                              </select>

                              <!-- Input del buscador -->
                              <input
                                type="text"
                                class="px-4 py-[9px] bg-white rounded-md text-neutral-500 text-sm font-light font-['Poppins'] leading-normal border border-gray-200"
                                placeholder="Buscar"
                                v-model="searchQuery"
                              />
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="row my-3">
                      <div class="w-full ">
                      </div>
                    </div>
                      <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg shadow-sm">
                            <thead class="bg-gray-50 text-gray-700 uppercase text-xs font-['Poppins']">
                              <tr>
                                <th class="py-3 px-6 text-style-custom text-left">Código</th>
                                <th class="py-3 px-6 text-style-custom text-left">Propiedad</th>
                                <th class="py-3 px-6 text-style-custom text-left">Tipo de Inmueble</th>
                                <th class="py-3 px-6 text-style-custom text-left">Movimiento</th>
                                <th class="py-3 px-6 text-style-custom text-left">Precio venta</th>
                                <th class="py-3 px-6 text-style-custom text-left">Precio Renta</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estado</th>
                                <th class="py-3 px-6 text-style-custom text-left">Municipio</th>
                                <th class="py-3 px-6 text-style-custom text-left">Estatus</th>
                                <th class="py-3 px-6 text-style-custom text-left">Acciones</th>
                              </tr>
                            </thead>
                            <tbody class="text-gray-700 text-sm divide-y divide-gray-200">
                              <tr
                                v-for="(properties, index) in filteredCargos"
                                :key="index"
                                class="hover:bg-gray-50 transition-colors duration-150"
                                >
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.property_code }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ truncatedDescription (properties.property_name) }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_property }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.type_movement}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.property_value}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.rent_value}}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.state }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">{{ properties.municipality }}</td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap" :class="{'opacity-50':  properties.translatedStatus === 'Desactivado'}">
                                  <span
                                    class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Poppins']"
                                    :class="{ 
                                      'bg-yellow-100 text-yellow-800': properties.translatedStatus === 'Sin estatus',
                                      'bg-red-100 text-red-800': properties.translatedStatus === 'Desactivado', 
                                      'bg-green-100 text-green-800': properties.translatedStatus === 'Activo'
                                    }"
                                  >
                                    {{ properties.translatedStatus || 'Sin estatus' }}
                                  </span>
                                </td>
                                <td class="py-3 px-6 custom-width-text whitespace-nowrap">
                                  <div class="relative" ref="el => menuContainers.push(el)">
                                    <!-- Contenedor clickeable -->
                                    <div 
                                      class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-100 transition-colors duration-150"
                                      @click.stop="toggleMenu(properties.id)"
                                    >
                                      <svg 
                                        xmlns="http://www.w3.org/2000/svg" 
                                        width="17" 
                                        height="4" 
                                        viewBox="0 0 17 4" 
                                        fill="none"
                                      >
                                        <path 
                                          fill-rule="evenodd" 
                                          clip-rule="evenodd" 
                                          d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" 
                                          fill="#FF4265"
                                        />
                                      </svg>
                                    </div>

                                    <!-- Menú desplegable -->
                                    <div 
                                      v-show="menuVisible === properties.id" 
                                      :class="{
                                        'absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 overflow-hidden': true,
                                        'bottom-full mb-1': index === filteredCargos.length - 1 || index === filteredCargos.length - 2, // Si es el último o antepenúltimo registro, despliega hacia arriba
                                        'top-full mt-1': index < filteredCargos.length - 2 // De lo contrario, despliega hacia abajo
                                      }"
                                    >
                                      <ul class="py-1">
                                        <!-- Ver -->
                                        <li  
                                          class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                          @click="ShowCargo(properties.id)"
                                        >
                                          Ver
                                        </li>
                                        <!-- Editar -->
                                        <li  
                                          class="px-4 py-2.5 flex items-center hover:bg-gray-50 cursor-pointer text-gray-700 text-sm font-['Poppins'] transition-colors duration-150"
                                          @click="editCargo(properties.id)"
                                        >
                                          Editar
                                        </li>
                                        <!-- Activar -->
                                        <li 
                                          v-if="properties.translatedStatus === 'Desactivado'" 
                                          class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-green-600"
                                          @click="confirmActive(properties.id)"
                                        >
                                          Activar
                                        </li>
                                        <!-- Desactivar -->
                                        <li 
                                          v-else 
                                          class="px-4 py-2 flex items-center hover:bg-gray-50 cursor-pointer text-red-600"
                                          @click="deleteCargo(properties.id)"
                                        >
                                          Desactivar
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- Vista Mobile - Cards (después del cierre de </table>) -->
                    <div class="lg:hidden flex flex-col gap-4 mt-4">
                      <div v-for="properties in filteredCargos" :key="properties.id" class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm" :class="{'opacity-60': properties.translatedStatus === 'Desactivado' || properties.translatedStatus === 'Bloqueado'}">
                        <div class="flex justify-between items-start pb-3 mb-3 border-b border-gray-100">
                          <div class="flex-1 space-y-2">
                            <div class="text-gray-900 font-medium text-base font-['Poppins']">{{ properties.property_name }}</div>
                            <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Poppins']"  :class="{ 
                              'bg-yellow-100 text-yellow-800': properties.translatedStatus === 'Sin estatus',
                              'bg-red-100 text-red-800': properties.translatedStatus === 'Desactivado', 
                              'bg-green-100 text-green-800': properties.translatedStatus === 'Activo'
                            }">
                            {{ properties.translatedStatus }}
                            </span>
                          </div>
                          <div class="relative" :ref="el => el && menuContainers.push(el)">
                            <div class="flex items-center justify-center w-10 h-10 rounded-full cursor-pointer hover:bg-gray-100 transition-colors"
                              @click="toggleMenu(properties.id)">
                              <svg xmlns="http://www.w3.org/2000/svg" width="17" height="4" viewBox="0 0 17 4" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.96152 0C3.04429 0 3.92304 0.896031 3.92304 2C3.92304 3.10397 3.04425 4 1.96152 4C0.878748 4 0 3.10397 0 2C0 0.896031 0.878792 0 1.96152 0ZM8.49978 0C9.58255 0 10.4613 0.896031 10.4613 2C10.4613 3.10397 9.58251 4 8.49978 4C7.41705 4 6.53826 3.10397 6.53826 2C6.53826 0.896031 7.41705 0 8.49978 0ZM15.0385 0C16.1213 0 17 0.896031 17 2C17 3.10397 16.1212 4 15.0385 4C13.9557 4 13.077 3.10397 13.077 2C13.077 0.896031 13.9557 0 15.0385 0Z" fill="#FF4265"/>
                              </svg>
                            </div>
                            <div 
                              v-show="menuVisible === properties.id" 
                              class="absolute right-0 mt-2 bg-white border border-gray-200 shadow-lg w-48 z-50 rounded-lg overflow-hidden">
                              <ul class="py-1 divide-y divide-gray-100">
                                <!-- Editar -->
                                <li class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] transition-colors" @click="editCargo(properties.id)">Editar</li>
                                <!-- Activar -->
                                <li v-if="properties.translatedStatus === 'Desactivado'" class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] text-green-600 transition-colors" @click="confirmActive(properties.id)">Activar</li>
                                <!-- Desactivar -->
                                <li v-else class="px-4 py-2.5 hover:bg-gray-50 cursor-pointer text-sm font-['Poppins'] text-red-600 transition-colors" @click="deleteCargo(properties.id)">Desactivar</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="space-y-4">
                          <div class="flex flex-col py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">Tipo de propiedad:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] break-words">{{ properties.type_property }}</span>
                          </div>
                          <div class="flex flex-col py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">Movimiento:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] break-words">{{ properties.type_movement }}</span>
                          </div>
                          <div class="flex flex-col py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">$ Venta:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] break-words">{{ properties.property_value }}</span>
                          </div>
                          <div class="flex flex-col py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">$ Renta:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] break-words">{{ properties.rent_value }}</span>
                          </div>
                          <div class="flex flex-col py-1">
                            <span class="text-gray-500 text-sm font-medium font-['Poppins']">Dirección:</span>
                            <span class="text-gray-900 text-sm font-['Poppins'] break-words">{{ properties.state }}, {{ properties.municipality }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <DeleteModal
                      v-if="showModal"
                      :visible="showModal"
                      @close="showModal = false"
                      @confirm="confirmDelete"
                    />
                    <div class="flex justify-between items-center w-full">
                      <div class="hidden md:block w-[278px] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal">
                        Mostrando {{ currentPage }} de {{ totalPages }}
                      </div>
                      <!-- Pagination Controls -->
                      <div class="flex justify-center md:justify-end items-center gap-1 mt-6 py-4">
                        <!-- Botón Anterior -->
                        <button 
                          @click="changePage(currentPage - 1)" 
                          :disabled="currentPage === 1"
                          class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                        >
                          <span class="hidden md:inline">Anterior</span>
                          <span class="md:hidden">&lt;</span>
                        </button>

                        <!-- Números de página -->
                        <span
                          v-for="(pageNumber, index) in visiblePages"
                          :key="pageNumber === '...' ? `dots-${index}` : `page-${pageNumber}`"
                          class="flex items-center"
                        >
                          <button
                            v-if="pageNumber !== '...'"
                            @click="changePage(pageNumber)"
                            class="px-3 py-2 border border-[#FFD8DF] text-sm font-['Poppins'] rounded transition-colors min-w-[40px]"
                            :class="pageNumber === currentPage 
                              ? 'bg-[#FF4265] text-white border-[#FF4265] font-medium' 
                              : 'bg-white text-[#FF4265] hover:bg-[#FFF5F7]'"
                          >
                            {{ pageNumber }}
                          </button>

                          <span
                            v-else
                            class="px-2 text-gray-500 font-['Poppins']"
                          >
                            ...
                          </span>
                        </span>

                        <!-- Botón Siguiente -->
                        <button 
                          @click="changePage(currentPage + 1)" 
                          :disabled="currentPage >= totalPages"
                          class="px-3 py-2 border border-[#FFD8DF] bg-white text-[#FF4265] text-sm font-['Poppins'] rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-100 hover:bg-[#FFF5F7] disabled:hover:bg-gray-100 min-w-[40px]"
                        >
                          <span class="hidden md:inline">Siguiente</span>
                          <span class="md:hidden">&gt;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <head>
                      <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
              </div> 
            </div> 
          </div> 
        </div> 
      </div> 
    </div>        

</template>
  
  
<script setup>
  import { ref, onMounted, onBeforeUnmount} from 'vue';
  import axios from 'axios';
  import { computed } from "vue";
  import { useStore } from 'vuex';
  import { useRoute } from "vue-router";
  import 'vue-toastification/dist/index.css';
  import Loader from '@/components/loaderComponent.vue';
  import DeleteModal from '@/components/properties/Modal/DeletePropertiesModal.vue';
  import { useRouter } from 'vue-router';
  
  // Referencias y estado
  const isLoading = ref(true); // Inicializamos isLoading
  //const page = ref(1); // Página actual
  const searchQuery = ref("");  // Para almacenar el término de búsqueda
  const menuVisible = ref(null);
  const showFilters = ref(false);
  const store = useStore();
  let session = computed(() => store.getters.getUserSession);
  const route = useRoute();
  //let userId = computed(() => route.params.id);
  let advisorId = computed(() => route.params.id);
  const properties = ref([]);
  //const company = ref([]); // Aquí guardaremos todos los roles
  //const showDeleteModal = ref(false); // Controla la visibilidad del modal
  const showModal = ref(false); // Controla la visibilidad del modal
  const selectedCargoId = ref(null);
  const router = useRouter();
  const currentPage = ref(1);
  const itemsPerPage = ref(20); // Number of items to show per page
  const menuContainers = ref([]); 
  const statusFilter = ref(''); // Nuevo ref para el filtro de estatus
  const propertyTypeFilter = ref('');
  const movementTypeFilter = ref(''); // NUEVO: Filtro por tipo de movimiento

  // Métodos
  async function get_propierties() {
      try {
          let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/property`;
          var options = {
              headers: {
                  "Content-Type": "application/json", 
                  Authorization: `Bearer ${session.value.token_api}`, 
              },
          };

          const response = await axios.get(url_cnn, options);

          if (response.status === 200 && response.data?.properties) {
              // Verificamos la respuesta con un console.log
              console.log(response.data.properties);

              // Mapear propiedades y traducir status
              properties.value = response.data.properties.map(property => {
                  //console.log("Estado original:", property.status_id);  // Verifica el estado original
                  const translatedStatus = translateStatus(property.status_id);
                  //console.log("Estado traducido:", translatedStatus); // Verifica la traducción
                  return {
                      ...property,
                      translatedStatus: translatedStatus
                  };
              });
          }

      } catch (error) {
          if (error.response.status === 401) {
              store.dispatch("clearUserSession");
              router.push({ name: "login" });
          }
      } finally {
          isLoading.value = false;
      }
  }

  const deleteCargo = (cargo_id) => {
    if (!cargo_id) {
      console.error("No se proporcionó un ID válido");
      return;
    }
    selectedCargoId.value = cargo_id;
    showModal.value = true;
  };
  
  const visiblePages = computed(() => {
    const total = totalPages.value;
    const current = currentPage.value;

    const pages = []; // ✅ declarar primero

    if (total <= 4) {
      for (let i = 1; i <= total; i++) {
        pages.push(i);
      }
      return pages;
    }

    pages.push(1);

    if (current > 3) {
      pages.push('...');
    }

    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (current < total - 2) {
      pages.push('...');
    }

    pages.push(total);

    return pages;
  });

  //const profileCompany = (id) => {
  //    console.log("ID del rol:", id); // Imprime el ID en la consola
  //    router.push({ name: 'compañia-profile', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
  //};

  async function confirmDelete() {
    showModal.value = false;
    isLoading.value = true;
    try {
      if (!selectedCargoId.value) {
        throw new Error("No se ha seleccionado ninguna propiedad");
      }

      const options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json'
        }
      };

      const data = { 
        property_id: selectedCargoId.value // Change cargo_id to property_id
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/property-delete`,
        data,
        options
      );

      if (response.status === 200) {
        await deleteFromPropiedades(selectedCargoId.value);
        await deleteFromEasyBroker(selectedCargoId.value);

        await get_propierties(); // Refresh the properties list
        return response.data.message;
      }
      isLoading.value = false;
    } catch (error) {
      console.error("Error al intentar eliminar la propiedad:", error);
      
      // Handle specific error cases
      if (error.response?.status === 404) {
        console.error("La propiedad no fue encontrada");
      } else if (error.response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      }
      
      throw error; // Re-throw the error to be handled by the caller if needed
    }
  }
  async function deleteFromPropiedades(propertyId) {
    let url = `${process.env.VUE_APP_API_BASE_URL}/propertiesComDelete/${propertyId}`;

    var options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.delete(url, options);
      
      if (response.status === 200) {
        console.log("Propiedad eliminada en propiedades.com");
      } else {
        console.log("Error al eliminar en propiedades.com", response.status);
      }
    } catch (error) {
      console.error("Error al eliminar en propiedades.com:", error);
    }
  }
  async function deleteFromEasyBroker(propertyId) {
    let url = `${process.env.VUE_APP_API_BASE_URL}/delete-easybroker/${propertyId}`;

    var options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.post(url, options);
      
      if (response.status === 200) {
        console.log("Propiedad eliminada en Easy Broker");
      } else {
        console.log("Error al eliminar en pEasy Broker", response.status);
      }
    } catch (error) {
      console.error("Error al eliminar en Easy Broker:", error);
    }
  }
  const confirmActive = async (cargo_id) => {
    isLoading.value = true;
    if (!cargo_id) {
      console.error("No se proporcionó un ID válido");
      return;
    }

    // Buscar la propiedad por ID
    const property = properties.value.find(p => p.id === cargo_id);
    if (!property) {
      console.error("Propiedad no encontrada con el ID:", cargo_id);
      return;
    }

    // Acceder a sus partners
    const easyBrokerPartner = property.partners?.find(p => p.partner === 'EasyBroker');
    const propiedadesComPartner = property.partners?.find(p => p.partner === 'PropiedadesCom');
    selectedCargoId.value = cargo_id;
    
    try {
      const options = {
        headers: {
          'Authorization': `Bearer ${session.value.token_api}`,
          'Content-Type': 'application/json',
        },
      };
      
      const data = { 
        property_id: selectedCargoId.value // Changed from cargo_id to property_id
      };

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/property-active`, 
        data, 
        options
      );

      if (response.status === 200) {
        showModal.value = false;
        console.log("Propiedad activada correctamente:", response.data.message);

        // EasyBroker
        if (!easyBrokerPartner || (easyBrokerPartner.status !== 'active' && easyBrokerPartner.status !== 'delete')) {
          await syncWithEasyBroker(selectedCargoId.value);
        } else if (easyBrokerPartner.status === 'delete') {
          await updateWithEasyBroker(selectedCargoId.value);
        } else {
          console.log("✅ EasyBroker ya activo, no se hace nada.");
        }

        // PropiedadesCom
        if (!propiedadesComPartner || propiedadesComPartner.status !== 'active') {
          await syncWithPropiedades(selectedCargoId.value);
        } else {
          console.log("✅ PropiedadesCom ya activo, no se sincroniza.");
        }

        await get_propierties();
        return response.data.message;
      }
      isLoading.value = false;
      return response.data.message;
    } catch (error) {
      console.error('Error al activar la propiedad:', error); // Updated error message
      
      // Handle specific error cases
      if (error.response?.status === 404) {
        console.error("La propiedad no fue encontrada");
      } else if (error.response?.status === 401) {
        store.dispatch("clearUserSession");
        router.push({ name: "login" });
      }
      
      throw error;
    }
  };
  async function syncWithPropiedades(propertyId) {
    let syncUrl = `${process.env.VUE_APP_API_BASE_URL}/propertiesComUpdate/${propertyId}`;

    let syncOptions = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const syncResponse = await axios.put(syncUrl, {}, syncOptions);
      if (syncResponse.status === 200) {
        console.log("success", "Sincronización con propiedades.com completada");
      } else {
        console.log("Error en sincronización: ", syncResponse.status);
      }
    } catch (error) {
      console.error("Error al sincronizar con propiedades.com:", error);
    }
  }
  async function syncWithEasyBroker(propertyId) {
    let url_sync = `${process.env.VUE_APP_API_BASE_URL}/enviar-easybroker/${propertyId}`;

    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.post(url_sync, {}, options);

      if (
        response.status === 200 &&
        Array.isArray(response.data) &&
        response.data[0]?.status === "success"
      ) {
        console.log("[SYNC SUCCESS]", response.data);
        console.log("success", "Propiedad sincronizada con EasyBroker");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        console.warn("[SYNC WARNING] Error en respuesta:", response.data);
      }

    } catch (error) {
      console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
      console.log("error", "Error al sincronizar con EasyBroker");
    }
  }
  async function updateWithEasyBroker(propertyId) {
    let url_sync = `${process.env.VUE_APP_API_BASE_URL}/editar-easybroker/${propertyId}`;

    const options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.post(url_sync, {}, options);

      // Validar que el código sea 200 y además el contenido indique éxito
      if (
        response.status === 200 &&
        Array.isArray(response.data) &&
        response.data[0]?.status === "success"
      ) {
        console.log("[SYNC SUCCESS]", response.data);
        console.log("success", "Propiedad activada correctamente en EasyBroker");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        console.warn("[SYNC WARNING] Error en respuesta:", response.data);
      }

    } catch (error) {
      console.error("[ERROR SYNCING WITH EASYBROKER]", error.response);
      console.log("error", "Error al sincronizar con EasyBroker");
    }
  }
  const translateStatus = (status) => {
    // Verifica si el estado es null o undefined
    if (status === null || status === undefined) {
      return 'Sin estatus';
    }

    const statusTranslations = {
      1: 'Activo',
      2: 'Desactivado',
      3: 'Eliminada',
      // Agrega más traducciones según sea necesario
    };

    return statusTranslations[status] || status; // Devuelve el estado original si no se encuentra traducción
  };
    const goToPropertyForm = (advisorId) => {
    router.push({ 
      name: 'propertyForm', 
      params: { advisorId } // Envías el ID del asesor como parámetro
    });
  };
    const editCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'propertyFormEdit', params: { id } }); // Asegúrate de que el nombre coincida con el de la ruta
    };

    const ShowCargo = (id) => {
      console.log("ID del rol:", id); // Imprime el ID en la consola
      router.push({ name: 'my_property_detail', params: { property_id: id }}); // Asegúrate de que el nombre coincida con el de la ruta
    };

    const resetPagination = () => {
      currentPage.value = 1;
    };

    const truncatedDescription = (property_name) => {
          const maxLength = 34; // Establece el límite de caracteres que quieres mostrar
          if (property_name.length > maxLength) {
            return property_name.substring(0, maxLength) + '...'; // Recorta y añade "..."
          }
          return property_name; // Si no es largo, muestra la descripción completa
        };
    const filteredCargos = computed(() => {
      if (!Array.isArray(properties.value)) return [];

      let filtered = properties.value;

      // Aplicar filtro de búsqueda por nombre y código
      if (searchQuery.value) {
          filtered = filtered.filter(property => {
              const nameMatch = property.property_name && property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase());
              const codeMatch = property.property_code && property.property_code.toLowerCase().includes(searchQuery.value.toLowerCase());
              return nameMatch || codeMatch; // Retorna verdadero si coincide con el nombre o el código
          });
      }

      // Aplicar filtro por tipo de inmueble
      if (propertyTypeFilter.value) {
          filtered = filtered.filter(property => 
              property.type_property === propertyTypeFilter.value
          );
      }

      // Aplicar filtro por tipo de movimiento (NUEVO FILTRO)
      if (movementTypeFilter.value) {
          filtered = filtered.filter(property => 
              property.type_movement === movementTypeFilter.value
          );
      }

      // Aplicar filtro por estatus
      if (statusFilter.value) {
          filtered = filtered.filter(property => 
              property.translatedStatus === statusFilter.value
          );
      }

      // Paginar los resultados
      const start = (currentPage.value - 1) * itemsPerPage.value;
      const end = start + itemsPerPage.value;

      return filtered.slice(start, end);
    });
    // Modificar el computed totalPages para considerar todos los filtros
    const totalPages = computed(() => {
        let filtered = properties.value;

        if (searchQuery.value) {
            filtered = filtered.filter(property =>
                property.property_name.toLowerCase().includes(searchQuery.value.toLowerCase()),
            );
        }

        if (propertyTypeFilter.value) {
            filtered = filtered.filter(property => 
                property.type_property === propertyTypeFilter.value
            );
        }

        if (movementTypeFilter.value) {
            filtered = filtered.filter(property => 
                property.type_movement === movementTypeFilter.value
            );
        }

        if (statusFilter.value) {
            filtered = filtered.filter(property =>
                property.translatedStatus === statusFilter.value
            );
        }

        return Math.ceil(filtered.length / itemsPerPage.value);
    });
    const changePage = (page) => {
      if (page >= 1 && page <= totalPages.value) {
        currentPage.value = page;
      }
    };
    // Manejo de clics fuera del menú
    const handleClickOutside = (event) => {
      // Si el clic no fue dentro de ningún contenedor de menú, cerrar el menú visible
      if (!menuContainers.value.some(container => container?.contains(event.target))) {
        menuVisible.value = null;
      }
    };

    const toggleMenu = (userId) => {
      menuVisible.value = menuVisible.value === userId ? null : userId;
    };
    
  //const showToast = (message) => {
  //successMessage.value = message;
  //setTimeout(() => {
  //  successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  //}, 3000);
  //};
  // Lifecycle hooks
  onMounted(() => {
  get_propierties();
  document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
      document.removeEventListener('click', handleClickOutside);
  });

 
  
</script>
  
<style scoped>
    /* Ocultar tabla en mobile, mostrar cards */
  @media (max-width: 1023px) {
    .overflow-x-auto {
      display: none !important;
    }
  }

  /* Ocultar cards en desktop */
  @media (min-width: 1024px) {
    .lg\:hidden {
      display: none !important;
    }
  }
</style>